export const payRollItem = {
  addition: [
    {
      additionName: "Leave",
      additionCategory: "monthly renumeration",
      defaultUnitAmount: "1000",
    },
    {
      additionName: "Arrears of salary",
      additionCategory: "additional renumeration",
      defaultUnitAmount: "1200",
    },
    {
      additionName: "Gratuity	",
      additionCategory: "monthly renumeration",
      defaultUnitAmount: "7000",
    },
  ],
};

export const salaryReport = [
  {
    empId: 29,
    empType: "",
    empName: "Waston",
    designation: "Associate Software Engineer",
    profileImg: "avatar-01.jpg",
    fromDate: new Date("6-02-2013"),
    toDate: new Date("6-02-2014"),
  },
  {
    empId: 13,
    empType: "",
    empName: "Dutch",
    designation: "Associate Software Engineer",
    profileImg: "nible.png",
    fromDate: new Date("7-02-2013"),
    toDate: new Date("7-02-2014"),
  },
  {
    empId: 33,
    empType: "",
    empName: "Jerry",
    designation: "Associate Software Engineer",
    profileImg: "avatar-06.png",
    fromDate: new Date("9-02-2013"),
    toDate: new Date("9-02-2014"),
  },
  {
    empId: 100,
    empType: "",
    empName: "Tom",
    designation: "Associate Software Engineer",
    profileImg: "avatar-07.jpg",
    fromDate: new Date("10-02-2013"),
    toDate: new Date("10-02-2014"),
  },
  {
    empId: 66,
    empType: "",
    empName: "Spike",
    designation: "Associate Software Engineer",
    profileImg: "avatar-05.jpeg",
    fromDate: new Date("10-01-2012"),
    toDate: new Date("10-01-2013"),
  },
];

export const employeePlList = [
  {
    empId: 29,
    empType: "",
    empName: "Waston",
    designation: "Associate Software Engineer",
    profileImg: "avatar-01.jpg",
    fromDate: new Date("6-02-2013"),
    toDate: new Date("6-02-2014"),
    pLSlpitUp: [
      {
        date: new Date("11-11-2019"),
        amountDebited: 0,
        amountEncashed: 700,
        outstandingAmount: 800,
      },
      {
        date: new Date("11-10-2019"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1500,
      },
      {
        date: new Date("10-9-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1000,
      },
      {
        date: new Date("9-8-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 500,
      },
    ],
  },
  {
    empId: 13,
    empType: "",
    empName: "Dutch",
    designation: "Associate Software Engineer",
    profileImg: "nible.png",
    fromDate: new Date("7-02-2013"),
    toDate: new Date("7-02-2014"),
    pLSlpitUp: [
      {
        date: new Date("11-11-2019"),
        amountDebited: 0,
        amountEncashed: 700,
        outstandingAmount: 800,
      },
      {
        date: new Date("11-10-2019"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1500,
      },
      {
        date: new Date("10-9-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1000,
      },
      {
        date: new Date("9-8-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 500,
      },
    ],
  },
  {
    empId: 33,
    empType: "",
    empName: "Jerry",
    designation: "Associate Software Engineer",
    profileImg: "avatar-06.png",
    fromDate: new Date("9-02-2013"),
    toDate: new Date("9-02-2014"),
    pLSlpitUp: [
      {
        date: new Date("11-11-2019"),
        amountDebited: 0,
        amountEncashed: 700,
        outstandingAmount: 800,
      },
      {
        date: new Date("11-10-2019"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1500,
      },
      {
        date: new Date("10-9-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1000,
      },
      {
        date: new Date("9-8-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 500,
      },
    ],
  },
  {
    empId: 100,
    empType: "",
    empName: "Tom",
    designation: "Associate Software Engineer",
    profileImg: "avatar-07.jpg",
    fromDate: new Date("10-02-2013"),
    toDate: new Date("10-02-2014"),
    pLSlpitUp: [
      {
        date: new Date("11-11-2019"),
        amountDebited: 0,
        amountEncashed: 700,
        outstandingAmount: 800,
      },
      {
        date: new Date("11-10-2019"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1500,
      },
      {
        date: new Date("10-9-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1000,
      },
      {
        date: new Date("9-8-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 500,
      },
    ],
  },
  {
    empId: 66,
    empType: "",
    empName: "Spike",
    designation: "Associate Software Engineer",
    profileImg: "avatar-05.jpeg",
    fromDate: new Date("10-01-2012"),
    toDate: new Date("10-01-2013"),
    pLSlpitUp: [
      {
        date: new Date("11-11-2019"),
        amountDebited: 0,
        amountEncashed: 700,
        outstandingAmount: 800,
      },
      {
        date: new Date("11-10-2019"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1500,
      },
      {
        date: new Date("10-9-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 1000,
      },
      {
        date: new Date("9-8-2016"),
        amountDebited: 500,
        amountEncashed: 0,
        outstandingAmount: 500,
      },
    ],
  },
];
